module.exports = __webpack_public_path__ + "img/icon_BS.886f708e.jpg";